import ev from "../util/enumValue";

enum PriceMode {

    DECIMAL_COMMA = ev('DECIMAL_COMMA', 1),
    DECIMAL_POINT = ev('DECIMAL_POINT', 2),
    DECIMAL_DASH = ev('DECIMAL_DASH', 3),
    DECIMAL_NO = ev('DECIMAL_NO', 4),
    DECIMAL_SMALL = ev('DECIMAL_SMALL', 5)
}

export default PriceMode;
